<template>
  <section class="system-builder__header--section">
    <h2>{{sharedState.currentStep.title}}</h2>
    <div class="system-builder__header--progress-container">
      <ol class="progress">
        <li class="is-active" data-step="" v-for="dot in parseInt(sharedState.currentStep.stepNumber)"></li>
        <li data-step="" v-for="step in numberStepsIncomplete"></li>
      </ol>
    </div>
    <span class="system-builder__header--back-button" @click="goBackStep"
          v-if="sharedState.currentStep.stepNumber > 1">< Back</span>
    <div class="system-builder__quick-nav" v-if="parseInt(sharedState.currentStep.stepNumber) > 1">
      <span @click="resetBuilder">Start Over</span>
    </div>
  </section>
</template>

<script>
  import store from '../../store/index'
  import router from '../../router/index'

  export default {
    name: 'header',
    data () {
      return {
        sharedState: store.state,
        numberSteps: 6
      }
    },
    methods: {
      goBackStep: function () {
        router.go(-1)

        // Get ID of step going to
        var stepName = ''
        var currentStepNumber = parseInt(this.sharedState.currentStep.stepNumber)

        for (var theStep in this.sharedState.steps) {
          if (parseInt(this.sharedState.steps[theStep].stepNumber) === currentStepNumber - 1) {
            stepName = this.sharedState.steps[theStep].id
          }
        }

        // Update to the correct state
        store.updateCurrentStateRoute(stepName)
      },
      resetBuilder: function () {
        store.resetBuilder()
      },
      subtractValues: function () {
        return parseInt(this.numberSteps - parseInt(this.sharedState.currentStep.stepNumber))
      }
    },
    computed: {
      numberStepsIncomplete: function () {
        return this.subtractValues()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// header.vue?6f946d6a